import { createApi } from '@reduxjs/toolkit/query/react';
import { PaginatedResponse } from '@/types';
import { ISector, SectorApi } from '../models';
import { API_ATTEND_TRACK_URL } from '@/utils';
import { createBaseQueryWithReauth } from '@/services';

const sectorService = createApi({
  reducerPath: 'sectorService',
  baseQuery: createBaseQueryWithReauth(API_ATTEND_TRACK_URL),
  tagTypes: ['Sectors'],
  endpoints: (builder) => ({
    getSectors: builder.query<PaginatedResponse<ISector>, void>({
      query: () => ({
        url: '/',
        params: {
          offset: 0,
          limit: 3,
        },
      }),
      providesTags: ['Sectors'],
      transformResponse: (
        response: PaginatedResponse<SectorApi>
      ): PaginatedResponse<ISector> => ({
        ...response,
        items: response.items.map((item) => ({
          ...item,
          isLocked: false,
        })),
      }),
    }),
  }),
});

export default sectorService;
export const { useGetSectorsQuery } = sectorService;
